import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {UrlService} from '../../../core/services/url.service';
import {AsideService} from '../../../core/services/aside.service';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class AppsComponent implements OnInit {

  constructor(
    private asideService: AsideService,
  ) {
  }


  ngOnInit(): void {
    this.updateAside();
  }


  updateAside() {
    this.asideService.replaceContextSections([
      {
        name: 'Apps',
        items: [
          {
            text: 'Home',
            path: UrlService.makeAppsHomeUrl(),
          },
          {
            text: 'Manage Apps',
            path: UrlService.makeAppsManageUrl(),
          },
        ],
      },
    ]);
  }
}
